(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyInfoQuery', CompanyInfoQuery);

    CompanyInfoQuery.$inject = ['$resource', 'ENV'];

    function CompanyInfoQuery($resource, ENV) {


        var getCurrentCompanyInfo = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/getCurrentCompanyInfo';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false},
                    'get': {
                        method: 'GET',
                        transformResponse: function (data) {
                            if (data) {
                                data = angular.fromJson(data);
                            }
                            return data;
                        }
                    }
                }
            );
        };


        return {
            getCurrentCompanyInfo: getCurrentCompanyInfo
        };
    }
})();
